import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ShipstationService } from 'src/app/services/shipstation.service';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';

@Component({
  selector: 'app-shipstation-new-connection',
  templateUrl: './shipstation-new-connection.component.html',
  styleUrls: ['./shipstation-new-connection.component.scss']
})
export class ShipstationNewConnectionComponent implements OnInit, OnDestroy {

  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  isDisabled: boolean = true;
  isSpin: boolean = false;
  destroy: Subject<void> = new Subject<void>();
  constructor(private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private shipstationServce: ShipstationService) { }

  ngOnInit(): void {
    this.anableSubmit();
  }

  form = this.fb.group({
    accessKey: ["", [Validators.required]],
    secretKey: ["", [Validators.required]],
  });

  anableSubmit() {
    this.form.valueChanges.pipe(takeUntil(this.destroy)).subscribe((response: any) => {
      this.isDisabled = !(response.accessKey.length > 0 && response.secretKey.length > 0)
    });
  }

  cancel() {
    this.close.emit();
  }

  onSubmit() {
    if (this.form.valid) {
      this.isDisabled = true;
      this.isSpin = true;
      this.shipstationServce.create(this.form.value)
        .pipe(takeUntil(this.destroy))
        .subscribe({
         next: (response:any) => {
          this.isDisabled = false;
          this.isSpin = false;
          this.saved.emit(this.form.getRawValue());
          this.form.reset();
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: "ShipStation account added successfully",
                action: 'Dismiss',
                type: 'success',
              },
            });
        },
         error: (err) => {
          this.isDisabled = false;
          this.isSpin = false;
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: "unsuccessfull added new shipstation",
                action: 'Dismiss',
                type: 'error',
              },
            });
         }
       });
    }
  }

  openShipstationPage() {
    window.open("https://ship.shipstation.com/settings/api", "_blank");
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.unsubscribe();
  }
}
